/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import AuthService from 'cio/services/auth';
import { inject as service } from '@ember/service';
import FacebookLeadAdsForm, { FacebookLeadAdsFormStatus } from 'cio/models/facebook-lead-ads-form';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import CustomForm, { CustomFormStatus } from 'cio/models/custom-form';
import CustomFormsService from 'cio/services/custom-forms';
import { isFacebookForm, formTypeLabel } from 'cio/utils/forms';

interface FormsDisconnectFormConfirmModalArgs {
  onClose: () => unknown;
  form: FacebookLeadAdsForm | CustomForm;
}

export default class FormsDisconnectFormConfirmModal extends Component<FormsDisconnectFormConfirmModalArgs> {
  @service auth!: AuthService;
  @service customForms!: CustomFormsService;
  @service facebookLeadAds!: FacebookLeadAdsService;

  @tracked enteredFormName = '';

  get formTypeLabel() {
    return formTypeLabel(this.args.form.formType);
  }

  get isSubmitDisabled() {
    return (
      !this.auth.hasPermission('journeys/forms/delete') ||
      this.submitTask.isRunning ||
      this.enteredFormName !== this.args.form.name
    );
  }

  submitTask = task(async () => {
    try {
      await this.disconnectForm();
      return this.args.onClose();
    } catch (e) {
      this.args.form.rollbackAttributes();
      throw e;
    }
  });

  async disconnectForm() {
    if (isFacebookForm(this.args.form)) {
      this.args.form.set('status', FacebookLeadAdsFormStatus.Inactive);
      await this.facebookLeadAds.disconnectForm(this.args.form);
    } else {
      this.args.form.set('status', CustomFormStatus.Disconnected);
      await this.customForms.disconnectForm(this.args.form);
    }
  }
}
